import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useSWRMutation from "swr/mutation";
import { useDispatch } from "react-redux";
import jwt_decode from "jwt-decode";
import { useLocation } from "react-router";

import { fetcherPost } from "../../../services/fetcher";
import {
  setLoadNavigation,
  setSnackbarMode,
  setSnackbarTitle,
  setUserData,
} from "../../../redux/features/settingSlice";
import Logout from "../../../utils/Logout";
import useRefreshToken from "../../../hooks/UseRefreshToken";

const SetLoginToken = () => {
  const accessToken = JSON.parse(localStorage.getItem("token")) || null;
  const refreshToken = JSON.parse(localStorage.getItem("rt")) || null;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const fromUrl = location.hash.search("=") + 1;
  const toUrl = location.hash.search("&");
  const urlToken = location.hash.slice(fromUrl, toUrl);
  const [fetchRefreshData] = useRefreshToken();

  const { trigger: verifyTrigger } = useSWRMutation(
    () => {
      if (!accessToken) {
        return null;
      }
      return [`${process.env.REACT_APP_API}/auth/token/verify/`, accessToken];
    },
    fetcherPost,
    {
      onError: (e) => {
        // Refresh Token
        fetchRefreshData();
      },
    }
  );

  useEffect(() => {
    async function verifyTrig() {
      await verifyTrigger({ token: accessToken });
    }

    accessToken && verifyTrig();
  }, [accessToken, verifyTrigger, refreshToken]);

  useEffect(() => {
    var minute = 1000 * 60;
    const interval = setInterval(fetchRefreshData, minute * 50);

    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshToken]);

  // Get Token
  const { trigger, isMutating } = useSWRMutation(
    () => {
      if (!urlToken) return null;

      return [process.env.REACT_APP_API + "/auth/social/google/"];
    },
    fetcherPost,
    {
      onSuccess: (data) => {
        localStorage.setItem("token", JSON.stringify(data.access_token));
        localStorage.setItem("rt", JSON.stringify(data.refresh_token));
        dispatch(setLoadNavigation(false));

        if (data.user.new_user) {
          navigate("/login/editname");
        } else {
          navigate("/profile");
        }
      },
      onError: (e) => {
        if (e.request.status === 400) {
          Logout(dispatch);

          dispatch(setSnackbarMode(true));
          dispatch(
            setSnackbarTitle("Login failed for unknown reason!Please try again")
          );

          dispatch(setLoadNavigation(false));
          navigate("/login");
        }
      },
    }
  );

  // localStorage.setItem(
  //   "token",
  //   JSON.stringify(
  //     "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbl90eXBlIjoiYWNjZXNzIiwiZXhwIjoxNjc2NjI4NTMzLCJpYXQiOjE2NzY2MjQ5MzMsImp0aSI6IjZmMmQ3MWQ1NzUyZTQwOWJiNDUwMGNmMzEzYmJjYzc5IiwidXNlcl9pZCI6MTd9.7jAtW_egd-8SYT3WufGrnWpXqkmE_YJJICqchUkwuj4"
  //   )
  // );
  // localStorage.setItem(
  //   "rt",
  //   JSON.stringify(
  //     "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbl90eXBlIjoicmVmcmVzaCIsImV4cCI6MTY4NDQwMDkzMywiaWF0IjoxNjc2NjI0OTMzLCJqdGkiOiI3OWE5Yzg1MTRlYjM0M2U0YTZjMmI5ZWYyNGNlY2MxZSIsInVzZXJfaWQiOjE3fQ.9vQv_u4ERD-OKKgK1Nzaa1X3mQCExo_5GEGaj-VFok4"
  //   )
  // );

  // Set User detail
  useEffect(() => {
    accessToken && dispatch(setUserData(jwt_decode(accessToken).user_id));
  }, [dispatch, accessToken]);

  useEffect(() => {
    isMutating && dispatch(setLoadNavigation(true));
  }, [dispatch, isMutating]);

  useEffect(() => {
    async function fetchData() {
      try {
        if (!!urlToken && !accessToken) {
          await trigger({ access_token: urlToken });
        }
      } catch {}
    }
    fetchData();
  }, [trigger, urlToken, accessToken]);

  return null;
};

export default SetLoginToken;
